import {toCamelCase} from 'case-converter'
import {
  fetchErrorsHandler,
  fetchStart,
  fetchSuccessful,
  fetchSynchronizer,
  getFetchDate
} from '~/helpers/prices/_utils/prices'

export const state = () => ({
  pricesServers: [],
  serversFetchDate: '',
  fetchingNow: false,
  fetchingResult: ''
})

export const mutations = {
  setServersPrices(state, value) {
    state.pricesServers = value
  },
  setServersFetchDate(state, value) {
    state.serversFetchDate = value
  },
  setFetchingState(state, value) {
    state.fetchingNow = value
  },
  setFetchingResult(state, value) {
    state.fetchingResult = value
  }
}

export const actions = {
  async fetchServersPrices({commit, state}, options) {
    if (state.fetchingNow) {
      return fetchSynchronizer(commit, state)
    } else {
      fetchStart(commit)

      return this.$http.$get('/api/servers/v2/service/server', options)
        .then(res => res.result)
        .then(res => toCamelCase(res))
        .then(prices => {
          commit('setServersPrices', prices)
          commit('setServersFetchDate', getFetchDate())

          fetchSuccessful(commit)

          return prices
        })
        .catch(err => fetchErrorsHandler(commit, err))
    }
  }
}

export const getters = {
  getServersFetchDate(state) {
    return state.serversFetchDate
  },
  getServersPrices(state) {
    return state.pricesServers
  }
}